export const GetWindParks = "GetWindParks";
export const GetWindParksSuccess = "GetWindParksSuccess";
export const GetWindParksError = "GetWindParksError";
export const GetWindPark = "GetWindPark";
export const GetWindParkSuccess = "GetWindParkSuccess";
export const GetWindParkError = "GetWindParkError";
export const SetGoogleConnection = "SetGoogleConnection";
export const GetTurbineStatus = "GetTurbineStatus";

